import { createFileRoute } from "@tanstack/react-router";
import ShopperInsightsV2 from "../../../views/ShopperInsightsV2";

export const Route = createFileRoute("/_authenticated/user/shopperinsightsV2")({
  component: ShopperInsightsV2,
  staticData: { application: "Reports" },
});
